import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { GeneralProviderFormWrapper } from '@modules/ai/ai-settings-form/sections/ai-configuration/common/general-provider-form-wrapper';
import { BedrockAiProviderForm } from '@modules/ai/common/forms';
import { assignTestId } from '@common/infra/tests/assign-test-id';
export function BedrockAiConfiguration(props) {
    const { provider, className, form, availableProvider } = props;
    const { fieldState } = useController({ name: `provider.bedrock`, control: form.control });
    return (_jsx(GeneralProviderFormWrapper, { label: "Amazon Bedrock", withTestConnection: true, className: className, fieldState: fieldState, ...props, ...assignTestId(provider.id), children: _jsx(BedrockAiProviderForm, { form: form, availableProvider: availableProvider }) }));
}
